import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Drawer/drawer';
import { css } from '@patternfly/react-styles';
export var DrawerSection = function DrawerSection(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement("div", Object.assign({
    className: css(styles.drawerSection, className)
  }, props), children);
};